<div class="main">
    <div class="dx-field-title" translate>apiKeys.pageTitle</div>
    <dx-data-grid #apiKeys
                  [dataSource]="dataSource"
                  keyExpr="id"
                  [columnAutoWidth]="true"
                  [wordWrapEnabled]="true"
                  [focusedRowEnabled]="true"
                  height="calc(100vh - 150px)"
                  hoverStateEnabled="true"
                  [errorRowEnabled]="false"
                  (onContextMenuPreparing)="onContextMenuPreparing($event)"
                  (onRowDblClick)="onRowDblClick($event)">
        <dxo-search-panel [visible]="true" [width]="250" [placeholder]="'_commons.search' | translate"></dxo-search-panel>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-paging [enabled]="false"></dxo-paging>
        <dxo-summary>
            <dxi-total-item column="description" [displayFormat]="'apiKeys.lblApiKeysCount' | translate" summaryType="count"></dxi-total-item>
        </dxo-summary>
        <dxo-toolbar>
            <dxi-item location="after">
                <div *dxTemplate>
                    <dx-button icon="add" [text]="'_commons.add' | translate" (onClick)="newApiKey()"></dx-button>
                </div>
            </dxi-item>
            <dxi-item location="after">
                <div *dxTemplate>
                    <dx-button icon="refresh" [text]="'_commons.refresh' | translate" (onClick)="loadDataSource()"></dx-button>
                </div>
            </dxi-item>
            <dxi-item name="searchPanel"></dxi-item>
        </dxo-toolbar>

        <dxi-column dataField="description" [caption]="'apiKeys.lblDescription' | translate"></dxi-column>
        <dxi-column [width]="150" dataField="apiKey" [caption]="'apiKeys.lblApiKey' | translate" cellTemplate="ctApiKey"
                    [allowFiltering]="false" [allowSorting]="false">
        </dxi-column>
        <div *dxTemplate="let cell of 'ctApiKey'">
            <dx-button class="key" icon="key" [hint]="'_commons.copy' | translate" ngxClipboard [cbContent]="cell.data.apiKey"
                       (onClick)="notifyCopy()"></dx-button>
        </div>
    </dx-data-grid>
</div>

<!-- New & Edit popup -->
<dx-popup [title]="'apiKeys.popupTitle' | translate" [height]="240" [(visible)]="isEditPopupVisible">
    <div *dxTemplate="let data of 'content'">
        <dx-scroll-view direction="vertical" *ngIf="isEditPopupVisible">
            <dx-validation-group #apiKeyValidation>
                <div class="dx-field">
                    <div class="dx-field-label" translate>apiKeys.lblDescription<span class="dx-field-item-required-mark">
                            *</span></div>
                    <div class="dx-field-value">
                        <dx-text-box [(value)]="selectedApiKey.description">
                            <dx-validator>
                                <dxi-validation-rule type="required" [message]="'apiKeys.msgNameRequired' | translate"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class="flex bottom-buttons">
                    <dx-button class="add" [text]="'_commons.add' | translate" (onClick)="createApiKey()"
                        [visible]="isNew"></dx-button>
                    <dx-button class="save" [text]="'_commons.save' | translate" (onClick)="updateApiKey()"
                        [visible]="!isNew"></dx-button>
                    <dx-button class="cancel" [text]="'_commons.cancel' | translate" (onClick)="this.isEditPopupVisible = false"></dx-button>
                </div>
            </dx-validation-group>
        </dx-scroll-view>
    </div>
</dx-popup>

<!-- Loading panel -->
<dx-load-panel [visible]="isLoadPanelVisible" [message]="'_commons.loading' | translate" [position]="{ of: '.app-content', boundary: '.app-content' }"></dx-load-panel>
